export const SINGLE_IMAGE_REQUEST = "SINGLE_IMAGE_REQUEST"
export const SINGLE_IMAGE_SUCCESS = "SINGLE_IMAGE_SUCCESS"
export const SINGLE_IMAGE_FAIL = "SINGLE_IMAGE_FAIL"

export const SINGLE_USER_REQUEST = "SINGLE_USER_REQUEST"
export const SINGLE_USER_SUCCESS = "SINGLE_USER_SUCCESS"
export const SINGLE_USER_FAIL = "SINGLE_USER_FAIL"

export const IMAGE_ML_DETAIL_REQUEST = "IMAGE_ML_DETAIL_REQUEST"
export const IMAGE_ML_DETAIL_SUCCESS = "IMAGE_ML_DETAIL_SUCCESS"
export const IMAGE_ML_DETAIL_FAIL = "IMAGE_ML_DETAIL_FAIL"